import { HttpResponseBase } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { Utilities } from '../services/utilities';



// ******************** Growls ********************//
export class AlertCommand {
    constructor(
        public operation: AlertCommandOperator,
        public message?: AlertMessage) { }

        static create(severity: MessageSeverity,summary: string, details: string, operation?: AlertCommandOperator) {
            return new AlertCommand(operation, new AlertMessage(severity, summary, details));
        }
}

export declare type AlertCommandOperator = 'clear' | 'add' | 'add_sticky';

export class AlertMessage {
    constructor(
        public severity: MessageSeverity,
        public summary: string,
        public detail: string) { }
}

export enum MessageSeverity {
    info = 'info',
    success = 'success',
    error = 'error',
    warn = 'warn',
    loading = 'loading'
}
// ******************** End ********************//

@Injectable({
  providedIn: 'root'
})
export class AlertService {
    private messages = new Subject<AlertCommand>();

    private loadingMessageTimeoutId: any;

    constructor() {

    }

    showMessage(summary: string);
    showMessage(summary: string, detail: string, severity: MessageSeverity);
    showMessage(data: any, separatorOrDetail?: string, severity?: MessageSeverity) {
        if (!severity) {
            severity = MessageSeverity.info;
        }

        if (data instanceof HttpResponseBase) {
            data = Utilities.getHttpResponseMessages(data);
            separatorOrDetail = Utilities.captionAndMessageSeparator;
        }

        if (data instanceof Array) {
            for (const message of data) {
                const msgObject = Utilities.splitInTwo(message, separatorOrDetail);

                this.showMessageHelper(msgObject.firstPart, msgObject.secondPart, severity, false);
            }
        } else {
            this.showMessageHelper(data, separatorOrDetail, severity, false);
        }
    }

    showStickyMessage(summary: string);
    showStickyMessage(summary: string, detail: string, severity: MessageSeverity, error?: any, onRemove?: () => any);
    showStickyMessage(data: string | string[] | HttpResponseBase, separatorOrDetail?: string, severity?: MessageSeverity, error?: any) {

        if (!severity) {
            severity = MessageSeverity.info;
        }

        if (data instanceof HttpResponseBase) {
            data = Utilities.getHttpResponseMessages(data);
            separatorOrDetail = Utilities.captionAndMessageSeparator;
        }

        if (data instanceof Array) {
            for (const message of data) {
                const msgObject = Utilities.splitInTwo(message, separatorOrDetail);

                this.showMessageHelper(msgObject.firstPart, msgObject.secondPart, severity, true);
            }
        } else {
            if (error) {
                const msg = `Severity: "${MessageSeverity[severity]}", Summary: "${data}", Detail: "${separatorOrDetail}", Error: "${Utilities.safeStringify(error)}"`;

                switch (severity) {
                    case MessageSeverity.info:
                        this.logInfo(msg);
                        break;
                    case MessageSeverity.success:
                        this.logMessage(msg);
                        break;
                    case MessageSeverity.error:
                        this.logError(msg);
                        break;
                    case MessageSeverity.warn:
                        this.logWarning(msg);
                        break;
                }
            }

            this.showMessageHelper(data, separatorOrDetail, severity, true);
        }
    }

    private showMessageHelper(summary: string, detail: string, severity: MessageSeverity, isSticky: boolean) {

        const alertCommand: AlertCommand = {
            operation: isSticky ? 'add_sticky' : 'add',
            message: { severity: severity, summary: summary, detail: detail },
        };

        this.messages.next(alertCommand);
    }

    resetStickyMessage() {
        this.messages.next({ operation: 'clear' });
    }

    startLoadingMessage(message = 'Loading...', caption = '') {
        clearTimeout(this.loadingMessageTimeoutId);

        this.loadingMessageTimeoutId = setTimeout(() => {
            this.showStickyMessage(caption, message, MessageSeverity.loading);
        }, 500);
    }

    async stopLoadingMessage(delay = 0) {
        await new Promise(resolve => setTimeout(resolve, delay));
        clearTimeout(this.loadingMessageTimeoutId);
        this.resetStickyMessage();
    }

    showValidationError() {
        this.resetStickyMessage();
        this.showStickyMessage('Missing Information', 'You have entered invalid or incomplete information. Please correct any errors and try again.', MessageSeverity.error);
    }

    logDebug(msg) {
        console.debug(msg);
    }

    logError(msg) {
        console.error(msg);
    }

    logInfo(msg) {
        console.info(msg);
    }

    logMessage(msg) {
        console.log(msg);
    }

    logTrace(msg) {
        console.trace(msg);
    }

    logWarning(msg) {
        console.warn(msg);
    }

    getMessageEvent(): Observable<AlertCommand> {
        return this.messages.asObservable();
    }
}



